import api, { REFRESH_KEY, TOKEN_KEY } from './api';

export const authService = {
  async login(email, password) {
    const { data } = await api.post('/api/auth/login', { email, password });
    localStorage.setItem(TOKEN_KEY, data.accessToken);
    localStorage.setItem(REFRESH_KEY, data.refreshToken);
    return data;
  },

  async me() {
    const { data } = await api.get('/api/auth/me');
    return data.user;
  },

  async logout() {
    const refreshToken = localStorage.getItem(REFRESH_KEY);
    try {
      if (refreshToken) await api.post('/api/auth/logout', { refreshToken });
    } finally {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(REFRESH_KEY);
    }
  },

  async logoutAll() {
    await api.post('/api/auth/logout-all');
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_KEY);
  },

  async changePassword(currentPassword, newPassword) {
    const { data } = await api.post('/api/auth/change-password', {
      currentPassword,
      newPassword,
    });
    return data;
  },
};

export default authService;
